// Standards Registry for typical manufacturing tolerances
// Optimized for nested selection UI

import { getDeviations } from './elementShape';
import { findMaterial, REFERENCE_TEMP_C } from '../data/materials';
import { grenzabmasse, klassen as iso286Klassen } from '../data/iso286.js';
import { ISO2768_1_GRENZEN, ISO2768_1_DATA, ISO2768_2_DATA } from '../data/iso2768.js';

const DIN16742_RANGES = [3, 6, 10, 18, 30, 50, 80, 120, 180, 250, 315, 400, 500, 630, 800, 1000];
const DIN16742_DATA = {
  tg1: { //  3,     6,    10,    18,    30,    50,    80,   120,  180,  250,  315,  400,  500,  630,  800,  1000
    wb: [0.007, 0.012, 0.018, 0.022, 0.026, 0.031, 0.037, 0.044, null, null, null, null, null, null, null, null],
    nwb: [0.012, 0.018, 0.022, 0.026, 0.031, 0.037, 0.044, 0.050, null, null, null, null, null, null, null, null]
  },
  tg2: { //  3,     6,    10,    18,    30,    50,    80,   120,   180,   250,   315,   400,   500,  630,  800, 1000
    wb: [0.013, 0.020, 0.029, 0.035, 0.042, 0.050, 0.060, 0.090, 0.130, 0.150, 0.160, 0.180, 0.200, null, null, null],
    nwb: [0.020, 0.029, 0.035, 0.042, 0.050, 0.060, 0.090, 0.130, 0.150, 0.160, 0.180, 0.200, 0.220, null, null, null]
  },
  tg3: { //  3,     6,    10,    18,    30,    50,    80,   120,   180,   250,   315,   400,   500,   630,   800,   1000
    wb: [0.020, 0.031, 0.050, 0.060, 0.070, 0.080, 0.100, 0.150, 0.200, 0.230, 0.260, 0.290, 0.400, 0.550, 0.630, 0.700],
    nwb: [0.031, 0.050, 0.060, 0.070, 0.080, 0.100, 0.150, 0.200, 0.230, 0.260, 0.290, 0.400, 0.550, 0.630, 0.700, 0.770]
  },
  tg4: { //  3,     6,    10,    18,    30,    50,    80,   120,   180,   250,   315,   400,   500,   630,   800,  1000
    wb: [0.030, 0.050, 0.080, 0.090, 0.110, 0.130, 0.150, 0.230, 0.320, 0.350, 0.410, 0.450, 0.630, 0.880, 1.000, 1.150],
    nwb: [0.050, 0.080, 0.090, 0.110, 0.130, 0.150, 0.230, 0.320, 0.350, 0.410, 0.450, 0.630, 0.880, 1.000, 1.150, 1.300]
  },
  tg5: { //  3,     6,    10,    18,    30,    50,    80,   120,   180,   250,   315,   400,   500,   630,   800,  1000
    wb: [0.050, 0.080, 0.110, 0.140, 0.170, 0.200, 0.230, 0.360, 0.500, 0.580, 0.650, 0.700, 1.000, 1.400, 1.600, 1.800],
    nwb: [0.080, 0.110, 0.140, 0.170, 0.200, 0.230, 0.360, 0.500, 0.580, 0.650, 0.700, 1.000, 1.400, 1.600, 1.800, 2.100]
  },
  tg6: { //  3,     6,    10,    18,    30,    50,    80,   120,   180,   250,   315,   400,   500,   630,   800,  1000
    wb: [0.070, 0.120, 0.180, 0.220, 0.260, 0.310, 0.370, 0.570, 0.800, 0.930, 1.050, 1.150, 1.600, 2.200, 2.500, 2.800],
    nwb: [0.120, 0.180, 0.220, 0.260, 0.310, 0.370, 0.570, 0.800, 0.930, 1.050, 1.150, 1.600, 2.200, 2.500, 2.800, 3.100]
  },
  tg7: { //  3,     6,    10,    18,    30,    50,    80,   120,   180,   250,   315,   400,   500,   630,   800,  1000
    wb: [0.130, 0.200, 0.290, 0.350, 0.420, 0.500, 0.600, 0.900, 1.250, 1.450, 1.600, 1.800, 2.600, 3.500, 4.000, 4.500],
    nwb: [0.200, 0.290, 0.350, 0.420, 0.500, 0.600, 0.900, 1.250, 1.450, 1.600, 1.800, 2.600, 3.500, 4.000, 4.500, 5.000]
  },
  tg8: { //  3,     6,    10,    18,    30,    50,    80,   120,   180,   250,   315,   400,   500,   630,   800,  1000
    wb: [0.200, 0.310, 0.450, 0.550, 0.650, 0.800, 0.950, 1.400, 2.000, 2.300, 2.600, 2.850, 4.000, 5.500, 6.250, 7.000],
    nwb: [0.310, 0.450, 0.550, 0.650, 0.800, 0.950, 1.400, 2.000, 2.300, 2.600, 2.850, 4.000, 5.500, 6.250, 7.000, 7.750]
  },
  tg9: { //  3,     6,    10,    18,    30,    50,    80,   120,   180,   250,   315,   400,   500,   630,    800,  1000
    wb: [0.300, 0.490, 0.750, 0.900, 1.050, 1.250, 1.500, 2.250, 3.150, 3.600, 4.050, 4.450, 6.200, 8.500, 10.000, 11.500],
    nwb: [0.300, 0.490, 0.750, 0.900, 1.050, 1.250, 1.500, 2.250, 3.150, 3.600, 4.050, 4.450, 6.200, 8.500, 10.000, 11.500]
  }
};

function getDin16742(nominal, tg, type) {
  const n = Math.abs(Number(nominal));
  const data = DIN16742_DATA[tg]?.[type];
  if (!data) return { lower: 0, upper: 0, tolerance: 0 };

  const idx = DIN16742_RANGES.findIndex(r => n <= r);
  const val = idx === -1 ? data[data.length - 1] : data[idx];

  if (val === null) return { lower: 0, upper: 0, tolerance: 0, outOfRange: true };
  return { lower: -val, upper: val, tolerance: val * 2 };
}

function getIso2768_2(nominal, category, clazz) {
  const n = Math.abs(Number(nominal));
  const data = ISO2768_2_DATA[category];
  if (!data) return { lower: 0, upper: 0, tolerance: 0 };

  if (category === 'runout') {
    const val = data[clazz] || 0.1;
    return { lower: -val, upper: val, tolerance: val * 2 };
  }

  // Über der letzten Bereichsgrenze (3000 mm) legt die Norm nichts fest.
  const idx = data.ranges.findIndex(r => n <= r);
  if (idx === -1) return { lower: 0, upper: 0, tolerance: 0, outOfRange: true };
  const val = data[clazz][idx];
  return { lower: -val, upper: val, tolerance: val * 2 };
}

// ISO 286-2 über die gemeinsame Datenbasis (src/data/iso286.js). type:
// 'bores' | 'shafts', clazz: Toleranzklasse wie 'H7' / 'g6'.
function getIso286_2(nominal, type, clazz) {
  const r = grenzabmasse(nominal, clazz);
  if (r.ausserhalb) return { lower: 0, upper: 0, tolerance: 0, outOfRange: true };
  if (r.nichtGenormt) return { lower: 0, upper: 0, tolerance: 0 };
  return { lower: r.unten, upper: r.oben, tolerance: r.toleranz };
}

// === ISO 8062-3 Gusstoleranzen ===
// DCT – Maßtoleranzen (Table 7), DCTG 1-16
// Ranges: ≤10, >10–16, >16–25, >25–40, >40–63, >63–100, >100–160, >160–250, >250–400, >400–630, >630–1000, >1000–1600
const ISO8062_DCT_RANGES = [10, 16, 25, 40, 63, 100, 160, 250, 400, 630, 1000, 1600];
const ISO8062_DCT_DATA = {
  //        ≤10   >16   >25   >40   >63  >100  >160  >250   >400   >630  >1000   >1600
  dctg1: [0.09, 0.10, 0.11, 0.12, 0.13, 0.14, 0.16, 0.18, null, null, null, null],
  dctg2: [0.13, 0.14, 0.15, 0.17, 0.18, 0.20, 0.22, 0.25, 0.28, null, null, null],
  dctg3: [0.18, 0.20, 0.22, 0.24, 0.26, 0.28, 0.32, 0.36, 0.40, 0.46, null, null],
  dctg4: [0.26, 0.28, 0.30, 0.34, 0.36, 0.40, 0.44, 0.50, 0.56, 0.64, 0.72, null],
  dctg5: [0.36, 0.38, 0.42, 0.46, 0.50, 0.56, 0.62, 0.70, 0.78, 0.90, 1.00, null],
  dctg6: [0.52, 0.54, 0.58, 0.64, 0.70, 0.78, 0.88, 1.00, 1.10, 1.20, 1.40, 1.60],
  dctg7: [0.74, 0.78, 0.82, 0.90, 1.00, 1.10, 1.20, 1.40, 1.60, 1.80, 2.00, 2.20],
  dctg8: [1.00, 1.10, 1.20, 1.30, 1.40, 1.60, 1.80, 2.00, 2.20, 2.60, 2.80, 3.20],
  dctg9: [1.50, 1.60, 1.70, 1.80, 2.00, 2.20, 2.50, 2.80, 3.20, 3.60, 4.00, 4.60],
  dctg10: [2.00, 2.20, 2.40, 2.60, 2.80, 3.20, 3.60, 4.00, 4.40, 5.00, 6.00, 7.00],
  dctg11: [2.80, 3.00, 3.20, 3.60, 4.00, 4.40, 5.00, 5.60, 6.20, 7.00, 8.00, 9.00],
  dctg12: [4.20, 4.40, 4.60, 5.00, 5.60, 6.00, 7.00, 8.00, 9.00, 10.00, 11.00, 13.00],
  dctg13: [6.00, 6.00, 6.00, 7.00, 8.00, 8.00, 10.00, 11.00, 12.00, 14.00, 16.00, 18.00],
  dctg14: [8.00, 8.00, 8.00, 10.00, 10.00, 12.00, 14.00, 16.00, 18.00, 20.00, 22.00, 26.00],
  dctg15: [12.00, 12.00, 12.00, 14.00, 14.00, 16.00, 18.00, 20.00, 22.00, 26.00, 30.00, 36.00],
  dctg16: [16.00, 16.00, 16.00, 18.00, 20.00, 22.00, 26.00, 30.00, 32.00, 36.00, 40.00, 44.00]
};

function getIso8062Dct(nominal, grade) {
  const n = Math.abs(Number(nominal));
  const data = ISO8062_DCT_DATA[grade];
  if (!data) return { lower: 0, upper: 0, tolerance: 0 };

  const idx = ISO8062_DCT_RANGES.findIndex(r => n <= r);
  const val = idx === -1 ? data[data.length - 1] : data[idx];

  if (val === null) return { lower: 0, upper: 0, tolerance: 0, outOfRange: true };
  const half = val / 2;
  return { lower: -half, upper: half, tolerance: val };
}

// GCT – Geometrische Toleranzen (Tables 8-11), GCTG 2-8
// Ranges: ≤10, >10–30, >30–100, >100–300, >300–1000, >1000–3000, >3000–10000, >10000–30000, >30000
const ISO8062_GCT_RANGES = [10, 30, 100, 300, 1000, 3000, 10000, 30000, Infinity];

// Base geometric series used across all tables (shifted by grade/table)
const GCT_BASE = [0.08, 0.12, 0.18, 0.27, 0.40, 0.60, 0.90, 1.40, 2.00, 3.00, 4.50, 7.00, 10.00, 14.00, 20.00, 30.00, 44.00];

// Table 8: Geradheit – offset 0 for GCTG 2
// Table 9: Ebenheit – offset 1 for GCTG 2 (one step coarser than straightness)
// Table 10: Rundheit, Parallelität, Rechtwinkligkeit, Symmetrie – offset 2 for GCTG 2
// Table 11: Koaxialität – offset 3 for GCTG 2
const GCT_TABLE_OFFSETS = {
  straightness: 0,
  flatness: 1,
  roundness_etc: 2,
  coaxiality: 3
};

function getIso8062Gct(nominal, tableType, grade) {
  const n = Math.abs(Number(nominal));
  const gradeNum = parseInt(grade.replace('gctg', ''));
  if (gradeNum < 2 || gradeNum > 8) return { lower: 0, upper: 0, tolerance: 0 };

  const tableOffset = GCT_TABLE_OFFSETS[tableType] ?? 0;
  const dimIdx = ISO8062_GCT_RANGES.findIndex(r => n <= r);
  const effectiveDimIdx = dimIdx === -1 ? ISO8062_GCT_RANGES.length - 1 : dimIdx;

  // Index into GCT_BASE: gradeOffset + dimIdx + tableOffset
  // GCTG 2 at ≤10mm for straightness = GCT_BASE[0] = 0.08
  const baseIdx = (gradeNum - 2) + effectiveDimIdx + tableOffset;
  const val = baseIdx < GCT_BASE.length ? GCT_BASE[baseIdx] : GCT_BASE[GCT_BASE.length - 1];

  return { lower: -val, upper: val, tolerance: val * 2 };
}

// === DIN EN ISO 13920 – Schweißkonstruktionen Allgemeintoleranzen ===
// Table 1: Längentoleranzen (± mm)
const ISO13920_LINEAR_RANGES = [30, 120, 400, 1000, 2000, 4000, 8000, 12000, 16000, 20000, Infinity];
const ISO13920_LINEAR_DATA = {
  //     ≤30  >30-120  >120-400  >400-1000  >1000-2000  >2000-4000  >4000-8000  >8000-12000  >12000-16000  >16000-20000  >20000
  A: [1,   1,   1,   2,   3,   4,   5,   6,   7,   8,   9],
  B: [2,   2,   3,   4,   6,   8,  10,  12,  14,  16,  18],
  C: [3,   4,   6,   8,  11,  14,  18,  21,  24,  27,  30],
  D: [4,   7,   9,  12,  16,  21,  27,  32,  36,  40,  44]
};

// Table 2: Winkeltoleranzen (in Grad-Dezimal, basierend auf kürzerem Schenkel)
const ISO13920_ANGULAR_RANGES = [400, 1000, Infinity];
const ISO13920_ANGULAR_DATA = {
  //       ≤400     >400-1000    >1000
  A: [20/60,    15/60,    10/60],     // ±20', ±15', ±10'
  B: [45/60,    30/60,    20/60],     // ±45', ±30', ±20'
  C: [1.0,      45/60,    30/60],     // ±1°, ±45', ±30'
  D: [1.5,      1+15/60,  1.0]        // ±1°30', ±1°15', ±1°
};

// Table 3: Geradheit, Ebenheit, Parallelität (mm)
const ISO13920_FORM_RANGES = [30, 120, 400, 1000, 2000, 4000, 8000, 12000, 16000, 20000, Infinity];
const ISO13920_FORM_DATA = {
  //     ≤30  >30-120  >120-400  >400-1000  >1000-2000  >2000-4000  >4000-8000  >8000-12000  >12000-16000  >16000-20000  >20000
  A: [0.5,  1.0,  1.5,  2.0,  2.5,  3.0,  4.0,  5.0,  6.0,  7.0,  8.0],
  B: [1.0,  2.0,  3.0,  4.0,  5.0,  6.0,  8.0,  9.0, 10.0, 11.0, 12.0],
  C: [1.5,  3.0,  4.0,  6.0,  8.0, 10.0, 13.0, 16.0, 18.0, 19.0, 20.0],
  D: [3.0,  4.0,  6.0,  8.0, 11.0, 16.0, 20.0, 25.0, 28.0, 30.0, 32.0]
};

function getIso13920(nominal, category, clazz) {
  const n = Math.abs(Number(nominal));

  if (category === 'weld_linear') {
    const data = ISO13920_LINEAR_DATA[clazz];
    if (!data) return { lower: 0, upper: 0, tolerance: 0 };
    const idx = ISO13920_LINEAR_RANGES.findIndex(r => n <= r);
    const val = idx === -1 ? data[data.length - 1] : data[idx];
    return { lower: -val, upper: val, tolerance: val * 2 };
  }

  if (category === 'weld_angular') {
    const data = ISO13920_ANGULAR_DATA[clazz];
    if (!data) return { lower: 0, upper: 0, tolerance: 0 };
    const idx = ISO13920_ANGULAR_RANGES.findIndex(r => n <= r);
    const val = idx === -1 ? data[data.length - 1] : data[idx];
    // Return angle tolerance in degrees (for display purposes)
    return { lower: -val, upper: val, tolerance: val * 2 };
  }

  if (category === 'weld_form') {
    const data = ISO13920_FORM_DATA[clazz];
    if (!data) return { lower: 0, upper: 0, tolerance: 0 };
    const idx = ISO13920_FORM_RANGES.findIndex(r => n <= r);
    const val = idx === -1 ? data[data.length - 1] : data[idx];
    return { lower: -val, upper: val, tolerance: val * 2 };
  }

  return { lower: 0, upper: 0, tolerance: 0 };
}

export const STANDARDS_GROUPS = [
  {
    id: 'iso2768_1',
    name: 'ISO 2768-1',
    shortName: 'ISO 2768-1',
    // Hyphen joiner: industry-conventional "ISO 2768-1-m" rather than
    // "ISO 2768-1 m". Other groups use the default space joiner.
    compactJoiner: '-',
    desc: 'Längenmaße (Allgemeintoleranzen)',
    items: [
      { id: 'iso2768f', name: 'f (fein)',      shortName: 'f', getTol: (n) => getIso2768(n, 'f') },
      { id: 'iso2768m', name: 'm (mittel)',    shortName: 'm', getTol: (n) => getIso2768(n, 'm') },
      { id: 'iso2768c', name: 'c (grob)',      shortName: 'c', getTol: (n) => getIso2768(n, 'c') },
      { id: 'iso2768v', name: 'v (sehr grob)', shortName: 'v', getTol: (n) => getIso2768(n, 'v') }
    ]
  },
  {
    id: 'iso286_2',
    name: 'ISO 286-2',
    shortName: 'ISO 286-2',
    desc: 'Passungssystem (ISO-Toleranzen)',
    items: [
      {
        id: 'bores',
        name: 'Bohrung (Innenmaß)',
        // ISO convention: uppercase letter (H7, D12, …) is implicitly
        // a bore tolerance, lowercase (h6, d11, …) a shaft — repeating
        // "Bohrung" / "Welle" in the cell is noise.
        shortName: null,
        subOptions: iso286Klassen().bohrungen.map(k => ({ id: k, name: k }))
      },
      {
        id: 'shafts',
        name: 'Welle (Außenmaß)',
        shortName: null,
        subOptions: iso286Klassen().wellen.map(k => ({ id: k, name: k }))
      }
    ]
  },
  {
    id: 'iso2768_2',
    name: 'ISO 2768-2',
    shortName: 'ISO 2768-2',
    desc: 'Form & Lage (Allgemeintoleranzen)',
    items: [
      {
        id: 'straightness',
        name: 'Geradheit & Ebenheit',
        shortName: 'G&E',
        subOptions: [
          { id: 'H', name: 'H (fein)',   shortName: 'H' },
          { id: 'K', name: 'K (mittel)', shortName: 'K' },
          { id: 'L', name: 'L (grob)',   shortName: 'L' }
        ]
      },
      {
        id: 'perpendicularity',
        name: 'Rechtwinkligkeit',
        // ISO 1101 form-tolerance symbol: ⊥ (U+22A5). Renders in
        // standard system fonts and is the canonical symbol on
        // technical drawings, so engineers parse it instantly.
        shortName: '⊥',
        subOptions: [
          { id: 'H', name: 'H (fein)',   shortName: 'H' },
          { id: 'K', name: 'K (mittel)', shortName: 'K' },
          { id: 'L', name: 'L (grob)',   shortName: 'L' }
        ]
      },
      {
        id: 'symmetry',
        name: 'Symmetrie',
        shortName: 'Sym.',
        subOptions: [
          { id: 'H', name: 'H (fein)',   shortName: 'H' },
          { id: 'K', name: 'K (mittel)', shortName: 'K' },
          { id: 'L', name: 'L (grob)',   shortName: 'L' }
        ]
      },
      {
        id: 'runout',
        name: 'Lauf',
        shortName: 'Lauf',
        subOptions: [
          { id: 'H', name: 'H (fein)',   shortName: 'H' },
          { id: 'K', name: 'K (mittel)', shortName: 'K' },
          { id: 'L', name: 'L (grob)',   shortName: 'L' }
        ]
      }
    ]
  },
  {
    id: 'din16742',
    name: 'DIN 16742 / ISO 20457',
    // The "/ ISO 20457" duplicates the same content under the
    // international number — fine for the picker title but noise
    // in the per-row cell. Keep only the German number in shortName.
    shortName: 'DIN 16742',
    desc: 'Kunststoff-Formteile (TG 1-9)',
    items: Array.from({ length: 9 }, (_, i) => ({
      id: `tg${i + 1}`,
      name: `TG ${i + 1}`,
      shortName: `TG${i + 1}`,
      subOptions: [
        { id: 'wb',  name: 'Werkzeuggebunden (W)',        shortName: 'W' },
        { id: 'nwb', name: 'Nicht Werkzeuggebunden (NW)', shortName: 'NW' }
      ]
    }))
  },
  {
    id: 'iso8062',
    name: 'ISO 8062-3',
    shortName: 'ISO 8062-3',
    desc: 'Gusstoleranzen (Maß- und Geometrisch)',
    items: [
      {
        id: 'dct',
        name: 'Maß (DCT)',
        // The DCTG/GCTG sub-codes already encode the tolerance type
        // (DCT = dimensional, GCT = geometric), so the item prefix
        // would be redundant in the cell.
        shortName: null,
        subOptions: Array.from({ length: 16 }, (_, i) => ({ id: `dctg${i + 1}`, name: `DCTG ${i + 1}`, shortName: `DCTG${i + 1}` }))
      },
      {
        id: 'gct_straightness',
        name: 'Geradheit (GCT)',
        shortName: null,
        subOptions: Array.from({ length: 7 }, (_, i) => ({ id: `gctg${i + 2}`, name: `GCTG ${i + 2}`, shortName: `GCTG${i + 2}` }))
      },
      {
        id: 'gct_flatness',
        name: 'Ebenheit (GCT)',
        shortName: null,
        subOptions: Array.from({ length: 7 }, (_, i) => ({ id: `gctg${i + 2}`, name: `GCTG ${i + 2}`, shortName: `GCTG${i + 2}` }))
      },
      {
        id: 'gct_roundness_etc',
        name: 'Rundheit /\nParallelität /\nRechtwinkl. /\nSymmetrie (GCT)',
        shortName: null,
        subOptions: Array.from({ length: 7 }, (_, i) => ({ id: `gctg${i + 2}`, name: `GCTG ${i + 2}`, shortName: `GCTG${i + 2}` }))
      },
      {
        id: 'gct_coaxiality',
        name: 'Koaxialität (GCT)',
        shortName: null,
        subOptions: Array.from({ length: 7 }, (_, i) => ({ id: `gctg${i + 2}`, name: `GCTG ${i + 2}`, shortName: `GCTG${i + 2}` }))
      }
    ]
  },
  {
    id: 'iso13920',
    name: 'DIN EN ISO 13920',
    shortName: 'ISO 13920',
    desc: 'Schweißkonstruktionen - Allgemeintoleranzen',
    items: [
      {
        id: 'weld_linear',
        name: 'Längentoleranzen',
        // The A/B/C/D class scope is per-item (linear / angular /
        // form), but conventionally written alone — the row's
        // Bezeichnung column carries the geometric context.
        shortName: null,
        subOptions: [
          { id: 'A', name: 'A (fein)',      shortName: 'A' },
          { id: 'B', name: 'B (mittel)',    shortName: 'B' },
          { id: 'C', name: 'C (grob)',      shortName: 'C' },
          { id: 'D', name: 'D (sehr grob)', shortName: 'D' }
        ]
      },
      {
        id: 'weld_angular',
        name: 'Winkeltoleranzen',
        shortName: null,
        subOptions: [
          { id: 'A', name: 'A (fein)',      shortName: 'A' },
          { id: 'B', name: 'B (mittel)',    shortName: 'B' },
          { id: 'C', name: 'C (grob)',      shortName: 'C' },
          { id: 'D', name: 'D (sehr grob)', shortName: 'D' }
        ]
      },
      {
        id: 'weld_form',
        name: 'Geradheit / Ebenheit /\nParallelität',
        shortName: null,
        subOptions: [
          { id: 'A', name: 'A (fein)',      shortName: 'A' },
          { id: 'B', name: 'B (mittel)',    shortName: 'B' },
          { id: 'C', name: 'C (grob)',      shortName: 'C' },
          { id: 'D', name: 'D (sehr grob)', shortName: 'D' }
        ]
      }
    ]
  }
];

/**
 * Compact label for the per-row Norm cell.
 *
 *   default:                     "${groupShort}<joiner>${itemShort} (${subShort})"
 *   item.shortName === null:     "${groupShort}<joiner>${subShort}"   (item part omitted)
 *   no sub-option:               "${groupShort}<joiner>${itemShort}"
 *
 * `compactJoiner` defaults to a space — only ISO 2768-1 wants a hyphen
 * to match the industry notation "ISO 2768-1-m". Setting `shortName:
 * null` on an item drops it from the label entirely — useful for ISO
 * 286-2 (Bohrung/Welle is implicit in the H7/h6 casing), ISO 8062-3
 * (DCTG/GCTG codes self-identify), and ISO 13920 (class letter is
 * scoped per item but conventionally written alone).
 */
function formatShortLabel(group, item, sub) {
  const groupShort = group.shortName ?? group.name;
  const joiner     = group.compactJoiner ?? ' ';
  const subShort   = sub ? (sub.shortName ?? sub.name) : null;
  // `=== null` is intentional: undefined means "no override, fall back
  // to item.name"; null means "explicitly hide the item segment".
  const itemShort  = item.shortName === null ? null : (item.shortName ?? item.name);

  if (!itemShort && subShort) {
    return `${groupShort}${joiner}${subShort}`;
  }
  if (subShort) {
    return `${groupShort}${joiner}${itemShort} (${subShort})`;
  }
  return `${groupShort}${joiner}${itemShort}`;
}

export const findStandard = (id) => {
  if (!id) return null;

  for (const group of STANDARDS_GROUPS) {
    // Try to find item by progressively splitting the id
    // This handles item IDs with underscores (e.g. 'gct_straightness_gctg4')
    let foundItem = null;
    let subId = null;

    // First try: exact match (no sub-option)
    foundItem = group.items.find(item => item.id === id);
    if (foundItem && !foundItem.subOptions) {
      return {
        ...foundItem,
        shortLabel: formatShortLabel(group, foundItem, null),
        groupName: group.name,
        groupDesc: group.desc
      };
    }

    // Try splitting at each underscore position from right to left
    const parts = id.split('_');
    for (let splitAt = parts.length - 1; splitAt >= 1; splitAt--) {
      const candidateBase = parts.slice(0, splitAt).join('_');
      const candidateSub = parts.slice(splitAt).join('_');
      const item = group.items.find(it => it.id === candidateBase);
      if (item) {
        foundItem = item;
        subId = candidateSub;
        break;
      }
    }

    if (foundItem) {
      if (subId && foundItem.subOptions) {
        const sub = foundItem.subOptions.find(s => s.id === subId);
        if (sub) {
          let getTol = () => ({ lower: 0, upper: 0, tolerance: 0 });

          if (group.id === 'din16742') {
            getTol = (n) => getDin16742(n, foundItem.id, sub.id);
          } else if (group.id === 'iso2768_2') {
            getTol = (n) => getIso2768_2(n, foundItem.id, sub.id);
          } else if (group.id === 'iso286_2') {
            getTol = (n) => getIso286_2(n, foundItem.id, sub.id);
          } else if (group.id === 'iso8062') {
            if (foundItem.id === 'dct') {
              getTol = (n) => getIso8062Dct(n, sub.id);
            } else {
              const tableType = foundItem.id.replace('gct_', '');
              getTol = (n) => getIso8062Gct(n, tableType, sub.id);
            }
          } else if (group.id === 'iso13920') {
            getTol = (n) => getIso13920(n, foundItem.id, sub.id);
          }

          return {
            ...foundItem,
            id: `${foundItem.id}_${sub.id}`,
            name: `${foundItem.name} (${sub.name})`,
            shortLabel: formatShortLabel(group, foundItem, sub),
            groupName: group.name,
            groupDesc: group.desc,
            getTol
          };
        }
      }
      return {
        ...foundItem,
        shortLabel: formatShortLabel(group, foundItem, null),
        groupName: group.name,
        groupDesc: group.desc
      };
    }
  }
  return null;
};

function getIso2768(nominal, clazz = 'm') {
  const n = Math.abs(Number(nominal));
  const idx = n < 0.5 ? -1 : ISO2768_1_GRENZEN.findIndex((g) => n <= g);
  const tolerance = idx === -1 ? null : ISO2768_1_DATA[clazz]?.[idx] ?? null;
  if (tolerance === null) return { lower: 0, upper: 0, tolerance: 0, outOfRange: true };
  return { lower: -tolerance, upper: tolerance, tolerance: tolerance * 2 };
}

export const iso2768m = (nominal) => getIso2768(nominal, 'm');

// Note: `getDeviations` lives in ./elementShape.js as the canonical
// helper. calculations.js imports it (top of file) for its math
// functions; consumers should import directly from elementShape.

function calcStatus(min, max, limits) {
  if (!limits || (limits.min === null && limits.max === null)) return 'none';

  const minLimit = limits.min !== null ? Number(limits.min) : -Infinity;
  const maxLimit = limits.max !== null ? Number(limits.max) : Infinity;

  const vMin = Math.round(Number(min) * 1000) / 1000;
  const vMax = Math.round(Number(max) * 1000) / 1000;

  const minOk = vMin >= minLimit;
  const maxOk = vMax <= maxLimit;

  return (minOk && maxOk) ? 'ok' : 'error';
}

// ─── Wärmeausdehnungs-Helper (Task #27) ───────────────────────────
//
// Linearer thermischer Beitrag der gesamten Toleranzkette zum
// Schließmaß bei Temperatur `tempC`. Pro Element:
//   ΔL_i = direction_i · nominal_i · α_i · (T - T_ref)
// Summiert ergibt das die Verschiebung des Schließmaßes gegenüber
// dem Tref-Zustand. Linear in T → Extremwerte des Schließmaßes
// liegen an T = Tmin oder T = Tmax (für Worst-Case + RSS).
//
// Elemente ohne `material` (oder mit unbekanntem material) tragen
// nichts bei — das macht die alte Tref-Berechnung als Spezialfall
// von thermal=disabled identisch.
function chainThermalShift(elements, tempC) {
  const dT = tempC - REFERENCE_TEMP_C;
  let total = 0;
  for (const el of elements) {
    const mat = findMaterial(el.material);
    if (!mat) continue;
    const dir = Number(el.direction) || 1;
    const n = Number(el.nominal) || 0;
    total += dir * n * mat.alpha * dT;
  }
  return total;
}

// Kennzeichnet einen aktiven thermischen Modus. Defensiv geprüft,
// damit fehlende/teil-gefüllte thermal-Objekte (z.B. aus alten Saves)
// das Verhalten nicht ändern.
function thermalActive(thermal) {
  return !!(thermal && thermal.enabled
    && Number.isFinite(Number(thermal.tMin))
    && Number.isFinite(Number(thermal.tMax)));
}

export function calculateWorstCase(elements, limits = { min: null, max: null }, thermal = null) {
  let nominalResult = 0, minRef = 0, maxRef = 0;
  elements.forEach(el => {
    const dir = Number(el.direction) || 1;
    const n = Number(el.nominal) || 0;
    const { lower: l, upper: u } = getDeviations(el);

    if (dir === 1) {
      nominalResult += n;
      minRef += (n + l);
      maxRef += (n + u);
    } else {
      nominalResult -= n;
      minRef -= (n + u);
      maxRef -= (n + l);
    }
  });

  // Ohne Wärmeausdehnung: identisch zum Verhalten vor Task #27.
  if (!thermalActive(thermal)) {
    return {
      nominal: nominalResult,
      min: minRef,
      max: maxRef,
      tolerance: maxRef - minRef,
      status: calcStatus(minRef, maxRef, limits)
    };
  }

  // Linearität → Extrema des Schließmaßes liegen an den Endpunkten
  // des Temperaturbereichs. Wir berechnen die thermische
  // Verschiebung einmal bei tMin und einmal bei tMax und legen die
  // resultierenden Intervalle übereinander.
  const shiftMin = chainThermalShift(elements, Number(thermal.tMin));
  const shiftMax = chainThermalShift(elements, Number(thermal.tMax));
  const lowerExtreme = Math.min(shiftMin, shiftMax);
  const upperExtreme = Math.max(shiftMin, shiftMax);
  const min = minRef + lowerExtreme;
  const max = maxRef + upperExtreme;

  return {
    nominal: nominalResult,    // Anzeige weiterhin bei Tref (Zeichnungsmaß)
    min,
    max,
    tolerance: max - min,
    status: calcStatus(min, max, limits),
    thermal: {
      shiftAtTmin: shiftMin,
      shiftAtTmax: shiftMax,
      tMin: Number(thermal.tMin),
      tMax: Number(thermal.tMax)
    }
  };
}

export function calculateRSS(elements, limits = { min: null, max: null }, thermal = null) {
  // For an asymmetric band (e.g. +0,3 / -0,1) the geometric centre of the
  // distribution sits at the band midpoint, not on the nominal — so the
  // resulting min/max must be offset by Σ midShift·dir, otherwise RSS
  // returns a symmetric spread even when WC clearly doesn't.
  let nominalResult = 0;
  let centerOffset = 0;
  let rssVarSum = 0;

  elements.forEach(el => {
    const dir = Number(el.direction) || 1;
    const n = Number(el.nominal) || 0;
    const { lower: l, upper: u } = getDeviations(el);

    nominalResult += (n * dir);
    const halfWidth = (u - l) / 2;
    const midShift = (u + l) / 2;
    if (!Number.isNaN(halfWidth)) rssVarSum += halfWidth * halfWidth;
    if (!Number.isNaN(midShift)) centerOffset += midShift * dir;
  });

  const rssHalfRange = Math.sqrt(rssVarSum);
  const center = nominalResult + centerOffset;

  if (!thermalActive(thermal)) {
    const vMin = center - rssHalfRange;
    const vMax = center + rssHalfRange;
    return {
      nominal: nominalResult,
      min: vMin,
      max: vMax,
      tolerance: rssHalfRange * 2,
      status: calcStatus(vMin, vMax, limits)
    };
  }

  // Thermische Verschiebung ist deterministisch (Materialeigenschaft,
  // kein Streuanteil) → kein Beitrag zur Varianz. Sie verschiebt nur
  // das Zentrum. Genauso wie bei WC liegt das Extremzentrum an einem
  // der Bereichsenden, also Envelope über beide.
  const shiftMin = chainThermalShift(elements, Number(thermal.tMin));
  const shiftMax = chainThermalShift(elements, Number(thermal.tMax));
  const centerLo = center + Math.min(shiftMin, shiftMax);
  const centerHi = center + Math.max(shiftMin, shiftMax);
  const vMin = centerLo - rssHalfRange;
  const vMax = centerHi + rssHalfRange;

  return {
    nominal: nominalResult,
    min: vMin,
    max: vMax,
    tolerance: vMax - vMin,
    status: calcStatus(vMin, vMax, limits),
    thermal: {
      shiftAtTmin: shiftMin,
      shiftAtTmax: shiftMax,
      tMin: Number(thermal.tMin),
      tMax: Number(thermal.tMax)
    }
  };
}
